angular.module('dictionary')
    .controller('DictionaryListController', function ($scope, data, $uibModalInstance, Dictionary, DictionaryService) {
        this.DictionaryService = DictionaryService;
        this.$onInit = () => {
            this.type = data.type;
            Dictionary.list({ type: this.type }).$promise.then(response => this.items = response);

            let listener = $scope.$on(`dictionary-${this.type}.updated`, () => {
                listener();
                this.$onInit();
            });
        }

        this.close = () => $uibModalInstance.close();
    })
